import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import SortIcon from 'mdi-react/SortIcon';
import FilterListIcon from 'mdi-react/FilterListIcon';

class UnitsSearchTableSortButton extends React.Component {
  static propTypes = {
    onRequestSort: PropTypes.func.isRequired,
  };

  state = {
    anchorEl: null,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleSort = property => (event) => {
    const { onRequestSort } = this.props;
    onRequestSort(event, property);
    this.handleClose();
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <div>
        <IconButton
          className=""
          color="inherit"
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <SortIcon />
        </IconButton>
        
        {this.props.groupedView ?
	      <Menu
	          id="simple-menu"
	          anchorEl={anchorEl}
	          open={Boolean(anchorEl)}
	          onClose={this.handleClose}
	          className="material-table__filter-menu"
	        >
	        	<MenuItem onClick={this.handleSort('count')} className="material-table__filter-menu-item">Matching Units</MenuItem>
				<MenuItem onClick={this.handleSort('avg_price')} className="material-table__filter-menu-item">Avg Offering Price</MenuItem>
				<MenuItem onClick={this.handleSort('low_bed')} className="material-table__filter-menu-item">Bedrooms</MenuItem>
		   </Menu>
	    :   
    	<Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          className="material-table__filter-menu"
        > 
          <MenuItem onClick={this.handleSort('full_street_address')} className="material-table__filter-menu-item">Address</MenuItem>
          <MenuItem onClick={this.handleSort('offering_price')} className="material-table__filter-menu-item">Offering Price</MenuItem>
          <MenuItem onClick={this.handleSort('bedrooms')} className="material-table__filter-menu-item">Bedrooms</MenuItem>
          <MenuItem onClick={this.handleSort('baths')} className="material-table__filter-menu-item"> Baths</MenuItem>

          <MenuItem onClick={this.handleSort('sq_ft')} className="material-table__filter-menu-item">Square Foot</MenuItem>
          <MenuItem onClick={this.handleSort('exterior_sq_ft')} className="material-table__filter-menu-item">Exterior SF</MenuItem>
          <MenuItem onClick={this.handleSort('monthly_fees')} className="material-table__filter-menu-item">Common Charge</MenuItem>
          <MenuItem onClick={this.handleSort('monthly_taxes')} className="material-table__filter-menu-item">Est Taxes</MenuItem>
         </Menu>
        }
        
      </div>
    );
  }
}

export default UnitsSearchTableSortButton;
